import QuickActionCard from "../quickactioncard/QuickActionCard";
import beneficaryIcon from "../../assets/icons/beneficary-Icon.png";
import currencyIcon from "../../assets/icons/currency-icon.png";
import newWalletIcon from "../../assets/icons/wallet-icon.png";
import transferIcon from "../../assets/icons/transfer-icon.png";
import receiveMoneyIcon from "../../assets/icons/receive-money-icon.png";
import sendMoneyIcon from "../../assets/icons/send-money-icon.png";
import splitBillIcon from "../../assets/icons/split-bills-icon.png";
import fundTransferIcon from "../../assets/icons/fund-transfer-icon.png";

const QuickActionSection = () => {
  const quickActionDetails = [
    { name: "New beneficiary", icon: beneficaryIcon, path: "/add-recipient" },
    { name: "Add new wallet", icon: newWalletIcon, path: "/wallet" },
    { name: "Receive money", icon: receiveMoneyIcon, path: "/request-money" },
    { name: "Split bills", icon: splitBillIcon, path: "/split-payment" },
    { name: "New currency conversion", icon: currencyIcon, path: "/convert" },
    { name: "Local fund transfer", icon: transferIcon, path: "/new-transfer" },
    { name: "Send money to a phone or email", icon: sendMoneyIcon, path: "/new-transfer" },
    { name: "International fund transfer", icon: fundTransferIcon, path: "/new-transfer" },
  ];

  return (
    <div className="dashboard-section py-3 h-100 d-flex flex-column">
      <div className="dashboard-section-header">
        <div>
          <h4>Quick action</h4>
        </div>
      </div>

      <div className="dashboard-action-grid">
        {quickActionDetails.map(({ name, icon, path }) => {
          return <QuickActionCard key={name} name={name} icon={icon} path={path} />;
        })}
      </div>
    </div>
  );
};

export default QuickActionSection;
